import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import PageNavigation from './navigation/PageNavigation';
import image from '../src/images/qr.png';

function isMobile() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	return /android|iPad|iPhone|iPod/i.test(userAgent.toLowerCase());
}

function App() {
	const isOnMobile = isMobile();

	return (
		<div className="App">
			{isOnMobile ? (
				<Router>
					<PageNavigation />
				</Router>
			) : (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100vh',
						backgroundColor: '#f9f9f9',
					}}
				>
					<div
						style={{
							background: '#fff',
							padding: '40px',
							borderRadius: '16px',
							boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
							textAlign: 'center',
							maxWidth: '400px',
							width: '90%',
						}}
					>
						<h2
							style={{
								marginBottom: '20px',
								fontSize: '1.5rem',
								color: '#333',
							}}
						>
							Open This App on Your Mobile
						</h2>
						<img
							src={image}
							alt="Scan to open on mobile"
							style={{ width: '200px', marginBottom: '20px' }}
						/>
						<p style={{ fontSize: '1rem', color: '#555' }}>
							Scan the QR code with your phone camera to continue.
						</p>
					</div>
				</div>
			)}
		</div>
	);
}

export default App;
